// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { features, logger } from '@/lib';
import { Streamline } from '../Streamline';
import { weasleyFlowType } from '../constants';
import { Section } from '@/components/Form/StyledComponents';
import { GenericSubmission } from '../../../FormSubmission';
// @ts-expect-error untyped import
import { AccountSectionHeader } from '../../../Components';
import { OnboardOptions } from '@/components/OnboardOptions';
import { ContactFieldsSection } from '@/components/ContactInformation';

export const OptionalPassword = (): JSX.Element => {
  const isStreamlineExperience = features.isActive(
    'isStreamlineOptionalExperience',
  );
  const isForcedGuest = features.isActive('shouldDisableSignup');

  useEffect(() => {
    logger.info(
      isStreamlineExperience
        ? 'rendering_streamline_password_optional_sign_up_flow'
        : 'rendering_password_optional_sign_up_flow',
    );
  }, []);

  if (isStreamlineExperience) {
    logger.info('rendering_streamline_password_optional_sign_up_flow');
    return (
      <Streamline flowType={weasleyFlowType.OPTIONAL_WITH_PASSWORD_FLOW} />
    );
  }

  logger.info('rendering_password_optional_sign_up_flow');
  return (
    <>
      <Section>
        <ContactFieldsSection />
        {!isForcedGuest && <AccountSectionHeader />}
        {!isForcedGuest && <OnboardOptions />}
      </Section>
      <GenericSubmission />
    </>
  );
};
